module.exports = __webpack_public_path__ + "resources/img/bg_solution_main_jp.7df5b38f7c315d4604e5169267e03b3c.png";